import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FusePageCarded } from '@fuse';
import DashboardHeader from './DashboardHeader';
import Grids from './Grids';
import * as Actions from './store/actions';

const Dashboard = props => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(Actions.getAllCluster());
		dispatch(Actions.getDashboard());
		dispatch(Actions.getCpuAvg());
		const intervalId = setInterval(() => {
			dispatch(Actions.getDashboard());
			dispatch(Actions.getCpuAvg());
		}, 10000);

		return () => clearInterval(intervalId);
	}, [dispatch]);

	const DashboardInfo = useSelector(({ dashboard }) => dashboard.dashboard.data);
	const CpuAvgData = useSelector(({ dashboard }) => dashboard.cpuAvg.data);
	
	return (
		<FusePageCarded
			classes={{
				content: 'flex',
				header: 'min-h-96 h-96 sm:h-136 sm:min-h-136'
			}}
			header={<DashboardHeader history={props.history} />}
			content={<Grids DashboardInfo={DashboardInfo} CpuAvgData={CpuAvgData} ></Grids>
			}
		/>
	);
};

export default Dashboard;
